import { AuthenticationService, ConfigurationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isDefined } from '@philips-internal/oswald-ui-utils';
import { findRouteById, getRoutes, normalizeRoutes } from './routes.js';
function minutesToMilliseconds(value) {
    return Number(value) * 60 * 1000;
}
async function getConfiguration() {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-authentication');
    return await get();
}
async function prepareRoutes(routes, configurationRoutes) {
    const forgotPasswordRoute = findRouteById(routes, configurationRoutes.forgotPassword);
    const homeRoute = findRouteById(routes, configurationRoutes.home);
    const inactivityRoute = findRouteById(routes, configurationRoutes.inactivity);
    const loginRoute = findRouteById(routes, configurationRoutes.login);
    const customRoutes = [];
    for (const route of configurationRoutes.custom ?? []) {
        const customRoute = findRouteById(routes, route);
        if (customRoute) {
            customRoutes.push(customRoute.path);
        }
    }
    if (!forgotPasswordRoute || !homeRoute || !inactivityRoute || !loginRoute) {
        throw Error('[Foundation]: One of your Authentication Configuration routes does not exist.');
    }
    return {
        custom: customRoutes,
        forgotPassword: forgotPasswordRoute.path,
        home: homeRoute.path,
        inactivity: inactivityRoute.path,
        login: loginRoute.path,
    };
}
async function loadAuthentication() {
    const rawConfiguration = await getConfiguration();
    const routes = await getRoutes();
    normalizeRoutes(routes, '/');
    const openIDConnectCallbackRoute = findRouteById(routes, rawConfiguration.openIDConnect?.callbackRoute);
    const openIDConnectErrorRoute = findRouteById(routes, rawConfiguration.openIDConnect?.errorRoute);
    // If array and empty, it means that there's no configuration file.
    if (Array.isArray(rawConfiguration) && rawConfiguration.length === 0) {
        return;
    }
    const configuration = {
        clientId: rawConfiguration.clientId,
        endpoints: rawConfiguration.endpoints,
        errorResponseMapper: rawConfiguration.errorResponseMapper,
        inactivity: {
            time: minutesToMilliseconds(rawConfiguration.inactivity.time),
        },
        openIDConnect: {
            callbackRoute: openIDConnectCallbackRoute?.path,
            errorRoute: openIDConnectErrorRoute?.path,
            externalLoginURL: rawConfiguration.openIDConnect?.externalLoginURL,
            externalLogoutURL: rawConfiguration.openIDConnect?.externalLogoutURL,
        },
        routes: await prepareRoutes(routes, rawConfiguration.routes),
    };
    if (isDefined(rawConfiguration.encryptedToken)) {
        // @ts-expect-error "Type 'boolean' is not assignable to type 'false'. ts(2322)"
        // Happens because at the type level we extend it expecting true or false, and here when assigning a boolean it gets confused and expects one of them.
        configuration.encryptedToken = rawConfiguration.encryptedToken;
    }
    ConfigurationService.setAuthenticationConfiguration(configuration);
    void AuthenticationService.restoreTokenFromStorage();
}
export { loadAuthentication, };
//# sourceMappingURL=authentication.js.map